import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import {useModalData} from '@Components/modal/hooks/useModalData';
import type {ReactElement} from 'react';

export default function ChangePlanModal(): ReactElement<any> {
  const modalId = MODALS_IDS.CHANGE_PLAN_MODAL;
  const panelId = `${modalId}-panel`;
  const modalData = useModalData(modalId);

  return (
    <Modal modalId={modalId} panelId={panelId} modalHeight="auto" modalWidth="600px">
      <LazyPanel panelDirectoryName="change-plan-modal" panelProps={{...modalData.panelProps, panelId}} />
    </Modal>
  );
}

export const openChangePlanModal = (preselectLevel?: number, preselectDuration?: number, prefillPromoCode?: string): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CHANGE_PLAN_MODAL,
      panelProps: {preselectLevel, preselectDuration, prefillPromoCode},
    })
  );
};
